
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.783 9.297l2.015.917.909 2.006a.413.413 0 00.752 0l.916-2.014 2.016-.909a.413.413 0 000-.751l-2.016-.917-.908-2.015a.413.413 0 00-.752 0L7.798 7.63l-2.015.909a.42.42 0 000 .76zm11.391-1.205a.827.827 0 00.81-.991 9.075 9.075 0 00-1.33-3.188.828.828 0 00-1.273-.124.803.803 0 00-.115 1.016 7.509 7.509 0 011.107 2.659c.074.372.42.628.8.628zM2.792 3.79a.826.826 0 00-1.272.123A8.801 8.801 0 00.19 7.101a.826.826 0 00.81.99c.38 0 .727-.255.801-.627a7.36 7.36 0 011.107-2.659c.207-.314.149-.743-.116-1.016zM8.26.833a.831.831 0 00-.99-.817 9.016 9.016 0 00-3.19 1.329.833.833 0 00-.124 1.272.804.804 0 001.016.115 7.474 7.474 0 012.652-1.106c.38-.066.636-.413.636-.793zm5.833.512a9.016 9.016 0 00-3.189-1.33.831.831 0 00-.991.818c0 .38.256.727.628.801.966.19 1.867.578 2.651 1.107a.804.804 0 001.016-.116.824.824 0 00-.115-1.28z"}}),_c('path',{attrs:{"d":"M9.086 16.348a7.405 7.405 0 01-6.162-3.303H4.13a.828.828 0 00.826-.825.828.828 0 00-.826-.826H.826A.828.828 0 000 12.22v3.303c0 .454.372.825.826.825a.828.828 0 00.826-.825v-1.404C3.296 16.464 6.005 18 9.086 18a9.074 9.074 0 008.26-5.31.836.836 0 00-.57-1.148c-.37-.082-.767.091-.924.446-1.173 2.569-3.759 4.36-6.766 4.36z"}})])
          )
        }
      }
    